/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

/*jslint latedef:false*/

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // ANIMATION ON SCROLL
        $(window).load(function(){
          window.setTimeout(function(){
            var el;
            $(".animate-block").each(function(i, el) {
                el = $(el);
                if (el.visible(true)) {
                  el.addClass("already-visible");
                }
            });
          }, 301);
        });

        var el;
        $(window).scroll(function() {
            $(".animate-block").each(function(i, el) {
              el = $(el);
              if (el.visible(true)) {
                  el.addClass("do-animation");
              }
            });
        });

        $(window).load(function() {
          $('.preloader').delay(250).fadeOut("slow");

          window.setTimeout(function(){
            $('.preloader').remove();
          }, 2500);
        });

        //remove spaces from phone number tel:
        $('a[href^="tel:"]').attr('href', function(_,v){
          return v.replace(/\(0\)|\s+/g,'');
        });

        /** ON SCROLL EVENTS **/

        //scroll to top
        $(".scroll").click(function(e) {
          e.preventDefault();
          $('body, html').animate({scrollTop: 1}, 800);
        });

        $('.fullpage').fullpage({
          licenseKey: '36AF7E33-506A4402-91BDE5EC-81F864DE',
          scrollOverflow : true,
          autoScrolling: true,
          scrollHorizontally: true,
          scrollBar: false,
          sectionSelector: '.section',
          responsiveWidth: 992,
          scrollOverflowOptions: {
            scrollbars: false
          },
          onLeave: function(origin, destination, direction){
            var logo = $(destination.item).data('logo-color');
            $('body').removeClass('logo-green logo-white logo-orange logo-inherit logo-undefined').addClass('logo-' + logo);
          }
        });

        $(document).on("click", ".btt", function(event) {
          $.fn.fullpage.moveTo(1);
        });

        /* FLEXSLIDER */
        $('.flexslider.testimonials').flexslider({
          controlNav: false,
          directionNav: false,
        });

        // /* SCROLLIFY FULL PAGE SCROLLING */
        // if ($(window).width() < 992) {
        //   $.scrollify({
        //     section: ".section-mobile",
        //     interstitialSection : ".disable-fullscreen",
        //     easing: "easeOutExpo",
        //     scrollSpeed: 800,
        //     offset: 1,
        //     updateHash: false,
        //     before: function(){
        //       current = $.scrollify.current();
        //       logo = current.data('logo-color');
        //       $('body').removeClass('logo-green logo-white logo-orange logo-inherit logo-undefined').addClass('logo-' + logo);
        //     },
        //     after: function(){
        //       //current = $.scrollify.current();
        //       //logo = current.data('logo-color');
        //       //$('body').removeClass('logo-green logo-white logo-orange logo-inherit logo-undefined').addClass('logo-' + logo);
        //     }
        //   });
        // }
        // else {
        //   $.scrollify({
        //     section: ".section",
        //     interstitialSection : ".disable-fullscreen",
        //     easing: "easeOutExpo",
        //     scrollSpeed: 800,
        //     offset: 1,
        //     updateHash: false,
        //     before: function(){
        //       current = $.scrollify.current();
        //       logo = current.data('logo-color');
        //       $('body').removeClass('logo-green logo-white logo-orange logo-inherit logo-undefined').addClass('logo-' + logo);
        //     },
        //     after: function(){
        //       //current = $.scrollify.current();
        //       //logo = current.data('logo-color');
        //       //$('body').removeClass('logo-green logo-white logo-orange logo-inherit logo-undefined').addClass('logo-' + logo);
        //     }
        //   });
        // }

        // $(window).resize(function() {
        //   $.scrollify.update();
        // });

        /** MENU TOGGLES **/

        $(".navbar-toggler").click(function() {
          $('body').toggleClass('menu-active');
          if($('body').hasClass('menu-active')) {
            $.scrollify.disable();
          } else {
            $.scrollify.enable();
          }

        });

        /* FILTER TOGGLE */
        $('.toggle').click(function(){
          $(this).toggleClass('active').parent().siblings().slideToggle();
        });

        /* ACCORDION */
        if($('#accordion').length){
          $('.collapse').on('shown.bs.collapse', function(){
                $(this).parent().addClass('active');
              });
              $('.collapse').on('hidden.bs.collapse', function(){
                $(this).parent().removeClass('active');
              });
        }

		
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

		
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        /** FLEXSLIDER **/
        $('.flexslider').flexslider({
          animation: 'fade',
          controlNav: false,
          directionNav: true,
          slideshow: true,
          slideshowSpeed: 5000,
          animationSpeed: 500,

          init: function(slider) {
            // set logo colour
            var logo = $(slider).find(".flex-active-slide").data('logo-color');
            $('body').addClass('logo-' + logo);
            $(slider).find(".flex-active-slide").addClass('flex-slide');
          },
          before: function(slider) {
            $(slider).find("li").removeClass('flex-slide');
            $(slider).find(".flex-active-slide").addClass('flex-init-slide');
          },
          after: function(slider) {
            // change logo colour
            $(slider).find("li").removeClass('flex-init-slide');
            $(slider).find(".flex-active-slide").addClass('flex-slide');
            var logo = $(slider).find(".flex-active-slide").data('logo-color');
            $('body').removeClass('logo-green logo-white logo-orange logo-inherit logo-undefined').addClass('logo-' + logo);
            $('.desc').removeClass('txt-green txt-white txt-orange txt-undefined').addClass('txt-' + logo);
          }
        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS


      }
    },
    // About us page, note the change from about-us to about_us.
    //'page_template_template_about': {
    'about': {
      init: function() {
        // JavaScript to be fired on the about us page

        if ($(window).width() < 992) {

          $.scrollify.disable();

          $(".navbar-toggler").unbind("click");
          $(".navbar-toggler").click(function() {
            $('body').toggleClass('menu-active');
            //$.scrollify.disable();
          });

          /** remove empty p tags **/
          $('p').each(function() {
            var $this = $(this);
            if($this.html().replace(/\s|&nbsp;/g, '').length === 0) {
              $this.remove();
            }
          });

        }

        // top align text in split section

        $('section.split').each(function() {
          col1 = $(this).find('.col1');
          col2 = $(this).find('.col2');
          if ( ($(col1).hasClass('txt')) && ($(col2).hasClass('txt')) ) {
            $(this).children('div').wrapInner('<div class="col-12"><div class="row no-gutter"></div></div>');
          }
        });

        // LAZY LOAD IMAGES
          $(function() {
          $("img.lazy").lazyload({
            effect: "fadeIn"
          });
        });
		

      }
    },
	  // Work Template
    //'page_template_template_work': {
	  'work': {
      init: function() {

        // disable scrollify
        $.scrollify.disable();

        $(".navbar-toggler").unbind("click");
        $(".navbar-toggler").click(function() {
          $('body').toggleClass('menu-active');
          //$.scrollify.disable();
        });

        // toggle show/hide filters
        $('.filter-title').on( 'click', 'a', function(e){
          e.preventDefault();
          if($('#project-filter').hasClass('active')){
            $('.filter-title button').fadeOut(200, function(){
              $('.filter-title span').fadeIn(400);
            });
            $('.toggle-filter').slideUp(600);
            $('#project-filter').removeClass('active');
          } else {
            $('.filter-title span').fadeOut(200, function(){
              $('.filter-title button').fadeIn(400);
            });
            $('.toggle-filter').slideDown(600);
            $('#project-filter').addClass('active');
          }
        });

        // active filter
        $('.filter-group').each( function( i, buttonGroup ) {
          var $filterGroup = $( buttonGroup );
          $filterGroup.on( 'click', 'a', function() {
            //event.preventDefault();
            $filterGroup.find('.active').removeClass('active');
            $( this ).addClass('active');
            //$(this).find('i').fadeToggle();
            //$('#project-filter .expand').slideToggle();
          });
        });

        // init Isotope
        var $grid = $('.grid').isotope({
          itemSelector: '.grid-item',
          stagger: 30,
          transitionDuration: '0.6s',
          originLeft: true,
        });

        // layout Isotope after each image loads (fixed issue with the images overlapping on first load)
        $grid.imagesLoaded().progress( function() {
          $grid.isotope('layout');
        });

        // store filter for each group
        var filters = {};

        $('.toggle-filter').on( 'click', 'a', function(event) {
          event.preventDefault();
          var $this = $(this);
          // get group key
          var $filterGroup = $this.parents('.filter-group');
          var filterGroup = $filterGroup.attr('data-filter-group');
          // set filter for group
          filters[ filterGroup ] = $this.attr('data-filter');
          // combine filters
          var filterValue = concatValues( filters );
          $grid.isotope({ filter: filterValue });
          $grid.find( 'a' ).addClass( 'already-visible' );
          //console.log( filterValue );
        });

        // flatten object by concatinating values
        function concatValues( obj ) {
          var value = '';
          for ( var prop in obj ) {
            value += obj[ prop ];
          }
          return value;
        }

        /** PROJECT NAMES ON HOVER **/
        // find mouse position
        var $mouseX = 0,
            $mouseY = 0,
            $scrollY = 0;

        // data caption position on mouse
        $(document).mousemove(function(e){
          $mouseX = e.pageX;
          $mouseY = e.pageY;
          $('#portfolio-caption').css({
            left: $mouseX + 20,
            top:  $mouseY
          });
        });

        // display data caption
        $('.grid-item').mouseenter(function(){
          var pCaption = $(this).attr('data-caption');
          $("#portfolio-caption").stop().text(pCaption).fadeIn();
        }).mouseleave(function(){
          $("#portfolio-caption").stop().fadeOut(400, function(){
            $(this).text('');
          });
        });


      }
    },
    // People Page
    'people': {
      init: function() {

        // disable scrollify
        $.scrollify.disable();

        $(".navbar-toggler").unbind("click");
        $(".navbar-toggler").click(function() {
          $('body').toggleClass('menu-active');
          //$.scrollify.disable();
        });

        // init Isotope
        var $grid = $('.grid').isotope({
          itemSelector: '.grid-item',
          //filter: '.residential',
          stagger: 30,
          transitionDuration: '0.6s',
          originLeft: true,
        });
        // layout Isotope after each image loads
        $grid.imagesLoaded().progress( function() {
          $grid.isotope('layout');
        });

        // filter items on menu click
        $( ".page-title a" )
          .mouseenter(function(e) {
            e.preventDefault();
            var filterValue = $(this).attr('data-filter');
            $('.page-title a').removeClass('active');
            $(this).addClass('active');
            $grid.isotope({ filter: filterValue });
          })
          .mouseleave(function(e) {
            e.preventDefault();
            $('.page-title a').removeClass('active');
            $grid.isotope({ filter: '*' });
          });

        $('.page-title a').on('touchstart',function(e){
          e.preventDefault();
          var filterValue = $(this).attr('data-filter');
          $('.page-title a').removeClass('active');
          $(this).addClass('active');
          $grid.isotope({ filter: filterValue });
        });



      }
    },
    // Individual People Pages
    'single_people': {
      init: function () {

        // disable scrollify
        $.scrollify.disable();

        $(".navbar-toggler").unbind("click");
        $(".navbar-toggler").click(function() {
          $('body').toggleClass('menu-active');
          //$.scrollify.disable();
        });

      }
    },
    'single_projects': {
    //'single': {
      init: function() {

      /** credit **/

        if ($('.credit').length) {
          var lastSection = $('.credit').prev(),
              lastSectionDiv = lastSection.find('.container');
          if ($(lastSection).hasClass('fullwidth')) {
            $('.credit').prependTo('.posts-navigation');
          } else {
            $('.credit').appendTo(lastSectionDiv);
          }
        }

        /** FLEXSLIDER **/
        $('.flexslider').flexslider({
          controlNav: true,
          directionNav: true,
          slideshow: true
        });

        // LAZY LOAD IMAGES
        $(function() {
          $("img.lazy").lazyload({
            //threshold: 800,
            effect: "fadeIn"
          });
		    });
		
      }
    },
    // Blog
    'blog': {
      init: function() {

        // disable scrollify
        $.scrollify.disable();

        $(".navbar-toggler").unbind("click");
        $(".navbar-toggler").click(function() {
          $('body').toggleClass('menu-active');
          //$.scrollify.disable();
        });

        $.ajaxSetup ({ cache: false });

        $(".grid-item a.standard").click(function(e){
          e.preventDefault();
          var href = $(this).attr('href');
          $("#load-article").hide();
          $('body').addClass('modal-open').removeClass('modal-fade-complete');
          window.setTimeout(function(){
            $('body').addClass('modal-slide-complete');
          }, 800);

          $("#load-article").load( href + ' #post-content', function(responseTxt, statusTxt, xhr ){
            if(statusTxt === "success") {
              //alert("External content loaded successfully from "+href);

              $('.flexslider').flexslider({
                controlNav: false,
                directionNav: true,
              });

              $("#load-article").fadeIn();
            }
            //if(statusTxt == "error")
              //alert("Error: " + xhr.status + ": " + xhr.statusText);
          });
        });

        $(".load-article-wrapper a").click(function(e){
          e.preventDefault();
          $('body').removeClass('modal-open modal-slide-complete');
          //SimpleBar.removeObserver();
          $('#blog-row').stop().fadeTo("fast", 0.01);
          window.setTimeout(function(){
            $('body').addClass('modal-fade-complete');
            $('.modal-fade-complete #blog-row').stop().fadeTo("fast", 1);
            $('body').removeClass('modal-fade-complete');
          }, 100);
          window.setTimeout(function(){
            //$('body').removeClass('modal-fade-complete');
            $('#load-article').html('');
          }, 1000);
        });

        $(".format-image").each(function(imgH) {
          var postDate = $(this).find(".get-post-meta").text();
          $(this).find(".post-meta").text(postDate).append('<i class="fa fa-instagram">');
          //$(this).find("img").css('height', imgH);
        });

      }
    },
    'single_post': {
      init: function() {

        // disable scrollify
        $.scrollify.disable();

        $(".navbar-toggler").unbind("click");
        $(".navbar-toggler").click(function() {
          $('body').toggleClass('menu-active');
          //$.scrollify.disable();
        });

        $(window).load(function() {
          $('.preloader').stop(true, true).fadeOut(400);

          window.setTimeout(function(){
            $('.preloader').remove();
          }, 2000);
        });

        $('.preloader').hide();

        var el;
        $(".simplebar-content").scroll(function() {
          $(".animate-block").each(function(i, el) {
            el = $(el);
            if (el.visible(true)) {
              el.addClass("do-animation");
            }
          });
        });

        $(".format-image").each(function(){
          var postDate = $(this).find(".get-post-meta").text();
          $(this).find(".post-meta").text(postDate).append('<i class="fa fa-instagram">');
        });

        //Flexslider
        $('.flexslider').flexslider({
          //animation: 'slide',
          controlNav: false,
          directionNav: true,
        });

      }
    },
	// Contact Template
    'page_template_template_contact': {
      init: function() {


      }
    }
  };	
	
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

/* jshint ignore:start */

/*
 * JQuery Visible - checks if element is in the visible viewport
 * https://cdnjs.cloudflare.com/ajax/libs/jquery-visible/1.2.0/jquery.visible.js?ver=4.4.5
 * Version 4.4.5 
 * 
 * Copyright 2012, Digital Fusion
 * Licensed under the MIT license.
 * http://teamdf.com/jquery-plugins/license/
 *
 * @author Sam Sehnert
 * @desc A small plugin that checks whether elements are within
 *       the user visible viewport of a web browser.
 *       only accounts for vertical position, not horizontal.
 */

(function($){
    var $w = $(window);
    $.fn.visible = function(partial,hidden,direction){

        if (this.length < 1) 
            return;

        var $t        = this.length > 1 ? this.eq(0) : this,
            t         = $t.get(0),
            vpWidth   = $w.width(),
            vpHeight  = $w.height(),
            direction = (direction) ? direction : 'both',
            clientSize = hidden === true ? t.offsetWidth * t.offsetHeight : true;

        if (typeof t.getBoundingClientRect === 'function'){

            // Use this native browser method, if available.
            var rec = t.getBoundingClientRect(),
                tViz = rec.top    >= 0 && rec.top    <  vpHeight,
                bViz = rec.bottom >  0 && rec.bottom <= vpHeight,
                lViz = rec.left   >= 0 && rec.left   <  vpWidth,
                rViz = rec.right  >  0 && rec.right  <= vpWidth,
                vVisible   = partial ? tViz || bViz : tViz && bViz,
                hVisible   = partial ? lViz || rViz : lViz && rViz;

            if(direction === 'both')
                return clientSize && vVisible && hVisible;
            else if(direction === 'vertical')
                return clientSize && vVisible;
            else if(direction === 'horizontal')
                return clientSize && hVisible;
        } else {

            var viewTop         = $w.scrollTop(),
                viewBottom      = viewTop + vpHeight,
                viewLeft        = $w.scrollLeft(),
                viewRight       = viewLeft + vpWidth,
                offset          = $t.offset(),
                _top            = offset.top,
                _bottom         = _top + $t.height(),
                _left           = offset.left,
                _right          = _left + $t.width(),
                compareTop      = partial === true ? _bottom : _top,
                compareBottom   = partial === true ? _top : _bottom,
                compareLeft     = partial === true ? _right : _left,
                compareRight    = partial === true ? _left : _right;

            if(direction === 'both')
                return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop)) && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
            else if(direction === 'vertical')
                return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop));
            else if(direction === 'horizontal')
                return !!clientSize && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
        }
    };

})(jQuery);

/*
 * Lazy Load - jQuery plugin for lazy loading images
 * Copyright (c) 2007-2013 Mika Tuupola
 * Licensed under the MIT license: http://www.opensource.org/licenses/mit-license.php
 * Project home: http://www.appelsiini.net/projects/lazyload
 * Version:  1.9.1
 */

(function($, window, document, undefined) {
    var $window = $(window);

    $.fn.lazyload = function(options) {
        var elements = this;
        var $container;
        var settings = {
            threshold       : 0,
            failure_limit   : 0,
            event           : "scroll",
            effect          : "show",
            container       : window,
            data_attribute  : "original",
            skip_invisible  : true,
            appear          : null,
            load            : null,
            placeholder     : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"
        };

        function update() {
            var counter = 0;

            elements.each(function() {
                var $this = $(this);
                if (settings.skip_invisible && !$this.is(":visible")) {
                    return;
                }
                if ($.abovethetop(this, settings) ||
                    $.leftofbegin(this, settings)) {
                        /* Nothing. */
                } else if (!$.belowthefold(this, settings) &&
                    !$.rightoffold(this, settings)) {
                        $this.trigger("appear");
                        /* if we found an image we'll load, reset the counter */
                        counter = 0;
                } else {
                    if (++counter > settings.failure_limit) {
                        return false;
                    }
                }
            });

        }

        if(options) {
            /* Maintain BC for a couple of versions. */
            if (undefined !== options.failurelimit) {
                options.failure_limit = options.failurelimit;
                delete options.failurelimit;
            }
            if (undefined !== options.effectspeed) {
                options.effect_speed = options.effectspeed;
                delete options.effectspeed;
            }

            $.extend(settings, options);
        }

        /* Cache container as jQuery as object. */
        $container = (settings.container === undefined ||
                      settings.container === window) ? $window : $(settings.container);

        /* Fire one scroll event per scroll. Not one scroll event per image. */
        if (0 === settings.event.indexOf("scroll")) {
            $container.bind(settings.event, function() {
                return update();
            });
        }

        this.each(function() {
            var self = this;
            var $self = $(self);

            self.loaded = false;

            /* If no src attribute given use data:uri. */
            if ($self.attr("src") === undefined || $self.attr("src") === false) {
                if ($self.is("img")) {
                    $self.attr("src", settings.placeholder);
                }
            }

            /* When appear is triggered load original image. */
            $self.one("appear", function() {
                if (!this.loaded) {
                    if (settings.appear) {
                        var elements_left = elements.length;
                        settings.appear.call(self, elements_left, settings);
                    }
                    $("<img />")
                        .bind("load", function() {

                            var original = $self.attr("data-" + settings.data_attribute);
                            $self.hide();
                            if ($self.is("img")) {
                                $self.attr("src", original);
                            } else {
                                $self.css("background-image", "url('" + original + "')");
                            }
                            $self[settings.effect](settings.effect_speed);

                            self.loaded = true;

                            /* Remove image from array so it is not looped next time. */
                            var temp = $.grep(elements, function(element) {
                                return !element.loaded;
                            });
                            elements = $(temp);

                            if (settings.load) {
                                var elements_left = elements.length;
                                settings.load.call(self, elements_left, settings);
                            }
                        })
                        .attr("src", $self.attr("data-" + settings.data_attribute));
                }
            });

            /* When wanted event is triggered load original image */
            /* by triggering appear.                              */
            if (0 !== settings.event.indexOf("scroll")) {
                $self.bind(settings.event, function() {
                    if (!self.loaded) {
                        $self.trigger("appear");
                    }
                });
            }
        });

        /* Check if something appears when window is resized. */
        $window.bind("resize", function() {
            update();
        });

        /* With IOS5 force loading images when navigating with back button. */
        /* Non optimal workaround. */
        if ((/(?:iphone|ipod|ipad).*os 5/gi).test(navigator.appVersion)) {
            $window.bind("pageshow", function(event) {
                if (event.originalEvent && event.originalEvent.persisted) {
                    elements.each(function() {
                        $(this).trigger("appear");
                    });
                }
            });
        }

        /* Force initial check if images should appear. */
        $(document).ready(function() {
            update();
        });

        return this;
    };

    /* Convenience methods in jQuery namespace.           */
    /* Use as  $.belowthefold(element, {threshold : 100, container : window}) */

    $.belowthefold = function(element, settings) {
        var fold;

        if (settings.container === undefined || settings.container === window) {
            fold = (window.innerHeight ? window.innerHeight : $window.height()) + $window.scrollTop();
        } else {
            fold = $(settings.container).offset().top + $(settings.container).height();
        }

        return fold <= $(element).offset().top - settings.threshold;
    };

    $.rightoffold = function(element, settings) {
        var fold;

        if (settings.container === undefined || settings.container === window) {
            fold = $window.width() + $window.scrollLeft();
        } else {
            fold = $(settings.container).offset().left + $(settings.container).width();
        }

        return fold <= $(element).offset().left - settings.threshold;
    };

    $.abovethetop = function(element, settings) {
        var fold;

        if (settings.container === undefined || settings.container === window) {
            fold = $window.scrollTop();
        } else {
            fold = $(settings.container).offset().top;
        }

        return fold >= $(element).offset().top + settings.threshold  + $(element).height();
    };

    $.leftofbegin = function(element, settings) {
        var fold;

        if (settings.container === undefined || settings.container === window) {
            fold = $window.scrollLeft();
        } else {
            fold = $(settings.container).offset().left;
        }

        return fold >= $(element).offset().left + settings.threshold + $(element).width();
    };

    $.inviewport = function(element, settings) {
         return !$.rightoffold(element, settings) && !$.leftofbegin(element, settings) &&
                !$.belowthefold(element, settings) && !$.abovethetop(element, settings);
     };

    /* Custom selectors for your convenience.   */
    /* Use as $("img:below-the-fold").something() or */
    /* $("img").filter(":below-the-fold").something() which is faster */

    $.extend($.expr[":"], {
        "below-the-fold" : function(a) { return $.belowthefold(a, {threshold : 0}); },
        "above-the-top"  : function(a) { return !$.belowthefold(a, {threshold : 0}); },
        "right-of-screen": function(a) { return $.rightoffold(a, {threshold : 0}); },
        "left-of-screen" : function(a) { return !$.rightoffold(a, {threshold : 0}); },
        "in-viewport"    : function(a) { return $.inviewport(a, {threshold : 0}); },
        /* Maintain BC for couple of versions. */
        "above-the-fold" : function(a) { return !$.belowthefold(a, {threshold : 0}); },
        "right-of-fold"  : function(a) { return $.rightoffold(a, {threshold : 0}); },
        "left-of-fold"   : function(a) { return !$.rightoffold(a, {threshold : 0}); }
    });

})(jQuery, window, document);

/*
 * jQuery FlexSlider v2.6.3
 * Copyright 2012 WooThemes
 * Contributing Author: Tyler Smith
 */
 !function($){var e=!0;$.flexslider=function(t,a){var n=$(t);n.vars=$.extend({},$.flexslider.defaults,a);var i=n.vars.namespace,s=window.navigator&&window.navigator.msPointerEnabled&&window.MSGesture,r=("ontouchstart"in window||s||window.DocumentTouch&&document instanceof DocumentTouch)&&n.vars.touch,o="click touchend MSPointerUp keyup",l="",c,d="vertical"===n.vars.direction,u=n.vars.reverse,v=n.vars.itemWidth>0,p="fade"===n.vars.animation,m=""!==n.vars.asNavFor,f={};$.data(t,"flexslider",n),f={init:function(){n.animating=!1,n.currentSlide=parseInt(n.vars.startAt?n.vars.startAt:0,10),isNaN(n.currentSlide)&&(n.currentSlide=0),n.animatingTo=n.currentSlide,n.atEnd=0===n.currentSlide||n.currentSlide===n.last,n.containerSelector=n.vars.selector.substr(0,n.vars.selector.search(" ")),n.slides=$(n.vars.selector,n),n.container=$(n.containerSelector,n),n.count=n.slides.length,n.syncExists=$(n.vars.sync).length>0,"slide"===n.vars.animation&&(n.vars.animation="swing"),n.prop=d?"top":"marginLeft",n.args={},n.manualPause=!1,n.stopped=!1,n.started=!1,n.startTimeout=null,n.transitions=!n.vars.video&&!p&&n.vars.useCSS&&function(){var e=document.createElement("div"),t=["perspectiveProperty","WebkitPerspective","MozPerspective","OPerspective","msPerspective"];for(var a in t)if(void 0!==e.style[t[a]])return n.pfx=t[a].replace("Perspective","").toLowerCase(),n.prop="-"+n.pfx+"-transform",!0;return!1}(),n.ensureAnimationEnd="",""!==n.vars.controlsContainer&&(n.controlsContainer=$(n.vars.controlsContainer).length>0&&$(n.vars.controlsContainer)),""!==n.vars.manualControls&&(n.manualControls=$(n.vars.manualControls).length>0&&$(n.vars.manualControls)),""!==n.vars.customDirectionNav&&(n.customDirectionNav=2===$(n.vars.customDirectionNav).length&&$(n.vars.customDirectionNav)),n.vars.randomize&&(n.slides.sort(function(){return Math.round(Math.random())-.5}),n.container.empty().append(n.slides)),n.doMath(),n.setup("init"),n.vars.controlNav&&f.controlNav.setup(),n.vars.directionNav&&f.directionNav.setup(),n.vars.keyboard&&(1===$(n.containerSelector).length||n.vars.multipleKeyboard)&&$(document).bind("keyup",function(e){var t=e.keyCode;if(!n.animating&&(39===t||37===t)){var a=39===t?n.getTarget("next"):37===t?n.getTarget("prev"):!1;n.flexAnimate(a,n.vars.pauseOnAction)}}),n.vars.mousewheel&&n.bind("mousewheel",function(e,t,a,i){e.preventDefault();var s=0>t?n.getTarget("next"):n.getTarget("prev");n.flexAnimate(s,n.vars.pauseOnAction)}),n.vars.pausePlay&&f.pausePlay.setup(),n.vars.slideshow&&n.vars.pauseInvisible&&f.pauseInvisible.init(),n.vars.slideshow&&(n.vars.pauseOnHover&&n.hover(function(){n.manualPlay||n.manualPause||n.pause()},function(){n.manualPause||n.manualPlay||n.stopped||n.play()}),n.vars.pauseInvisible&&f.pauseInvisible.isHidden()||(n.vars.initDelay>0?n.startTimeout=setTimeout(n.play,n.vars.initDelay):n.play())),m&&f.asNav.setup(),r&&n.vars.touch&&f.touch(),(!p||p&&n.vars.smoothHeight)&&$(window).bind("resize orientationchange focus",f.resize),n.find("img").attr("draggable","false"),setTimeout(function(){n.vars.start(n)},200)},asNav:{setup:function(){n.asNav=!0,n.animatingTo=Math.floor(n.currentSlide/n.move),n.currentItem=n.currentSlide,n.slides.removeClass(i+"active-slide").eq(n.currentItem).addClass(i+"active-slide"),s?(t._slider=n,n.slides.each(function(){var e=this;e._gesture=new MSGesture,e._gesture.target=e,e.addEventListener("MSPointerDown",function(e){e.preventDefault(),e.currentTarget._gesture&&e.currentTarget._gesture.addPointer(e.pointerId)},!1),e.addEventListener("MSGestureTap",function(e){e.preventDefault();var t=$(this),a=t.index();$(n.vars.asNavFor).data("flexslider").animating||t.hasClass("active")||(n.direction=n.currentItem<a?"next":"prev",n.flexAnimate(a,n.vars.pauseOnAction,!1,!0,!0))})})):n.slides.on(o,function(e){e.preventDefault();var t=$(this),a=t.index(),s=t.offset().left-$(n).scrollLeft();0>=s&&t.hasClass(i+"active-slide")?n.flexAnimate(n.getTarget("prev"),!0):$(n.vars.asNavFor).data("flexslider").animating||t.hasClass(i+"active-slide")||(n.direction=n.currentItem<a?"next":"prev",n.flexAnimate(a,n.vars.pauseOnAction,!1,!0,!0))})}},controlNav:{setup:function(){n.manualControls?f.controlNav.setupManual():f.controlNav.setupPaging()},setupPaging:function(){var e="thumbnails"===n.vars.controlNav?"control-thumbs":"control-paging",t=1,a,s;if(n.controlNavScaffold=$('<ol class="'+i+"control-nav "+i+e+'"></ol>'),n.pagingCount>1)for(var r=0;r<n.pagingCount;r++){s=n.slides.eq(r),void 0===s.attr("data-thumb-alt")&&s.attr("data-thumb-alt","");var c=""!==s.attr("data-thumb-alt")?c=' alt="'+s.attr("data-thumb-alt")+'"':"";if(a="thumbnails"===n.vars.controlNav?'<img src="'+s.attr("data-thumb")+'"'+c+"/>":'<a href="#">'+t+"</a>","thumbnails"===n.vars.controlNav&&!0===n.vars.thumbCaptions){var d=s.attr("data-thumbcaption");""!==d&&void 0!==d&&(a+='<span class="'+i+'caption">'+d+"</span>")}n.controlNavScaffold.append("<li>"+a+"</li>"),t++}n.controlsContainer?$(n.controlsContainer).append(n.controlNavScaffold):n.append(n.controlNavScaffold),f.controlNav.set(),f.controlNav.active(),n.controlNavScaffold.delegate("a, img",o,function(e){if(e.preventDefault(),""===l||l===e.type){var t=$(this),a=n.controlNav.index(t);t.hasClass(i+"active")||(n.direction=a>n.currentSlide?"next":"prev",n.flexAnimate(a,n.vars.pauseOnAction))}""===l&&(l=e.type),f.setToClearWatchedEvent()})},setupManual:function(){n.controlNav=n.manualControls,f.controlNav.active(),n.controlNav.bind(o,function(e){if(e.preventDefault(),""===l||l===e.type){var t=$(this),a=n.controlNav.index(t);t.hasClass(i+"active")||(a>n.currentSlide?n.direction="next":n.direction="prev",n.flexAnimate(a,n.vars.pauseOnAction))}""===l&&(l=e.type),f.setToClearWatchedEvent()})},set:function(){var e="thumbnails"===n.vars.controlNav?"img":"a";n.controlNav=$("."+i+"control-nav li "+e,n.controlsContainer?n.controlsContainer:n)},active:function(){n.controlNav.removeClass(i+"active").eq(n.animatingTo).addClass(i+"active")},update:function(e,t){n.pagingCount>1&&"add"===e?n.controlNavScaffold.append($('<li><a href="#">'+n.count+"</a></li>")):1===n.pagingCount?n.controlNavScaffold.find("li").remove():n.controlNav.eq(t).closest("li").remove(),f.controlNav.set(),n.pagingCount>1&&n.pagingCount!==n.controlNav.length?n.update(t,e):f.controlNav.active()}},directionNav:{setup:function(){var e=$('<ul class="'+i+'direction-nav"><li class="'+i+'nav-prev"><a class="'+i+'prev" href="#">'+n.vars.prevText+'</a></li><li class="'+i+'nav-next"><a class="'+i+'next" href="#">'+n.vars.nextText+"</a></li></ul>");n.customDirectionNav?n.directionNav=n.customDirectionNav:n.controlsContainer?($(n.controlsContainer).append(e),n.directionNav=$("."+i+"direction-nav li a",n.controlsContainer)):(n.append(e),n.directionNav=$("."+i+"direction-nav li a",n)),f.directionNav.update(),n.directionNav.bind(o,function(e){e.preventDefault();var t;""!==l&&l!==e.type||(t=$(this).hasClass(i+"next")?n.getTarget("next"):n.getTarget("prev"),n.flexAnimate(t,n.vars.pauseOnAction)),""===l&&(l=e.type),f.setToClearWatchedEvent()})},update:function(){var e=i+"disabled";1===n.pagingCount?n.directionNav.addClass(e).attr("tabindex","-1"):n.vars.animationLoop?n.directionNav.removeClass(e).removeAttr("tabindex"):0===n.animatingTo?n.directionNav.removeClass(e).filter("."+i+"prev").addClass(e).attr("tabindex","-1"):n.animatingTo===n.last?n.directionNav.removeClass(e).filter("."+i+"next").addClass(e).attr("tabindex","-1"):n.directionNav.removeClass(e).removeAttr("tabindex")}},pausePlay:{setup:function(){var e=$('<div class="'+i+'pauseplay"><a href="#"></a></div>');n.controlsContainer?(n.controlsContainer.append(e),n.pausePlay=$("."+i+"pauseplay a",n.controlsContainer)):(n.append(e),n.pausePlay=$("."+i+"pauseplay a",n)),f.pausePlay.update(n.vars.slideshow?i+"pause":i+"play"),n.pausePlay.bind(o,function(e){e.preventDefault(),""!==l&&l!==e.type||($(this).hasClass(i+"pause")?(n.manualPause=!0,n.manualPlay=!1,n.pause()):(n.manualPause=!1,n.manualPlay=!0,n.play())),""===l&&(l=e.type),f.setToClearWatchedEvent()})},update:function(e){"play"===e?n.pausePlay.removeClass(i+"pause").addClass(i+"play").html(n.vars.playText):n.pausePlay.removeClass(i+"play").addClass(i+"pause").html(n.vars.pauseText)}},touch:function(){function e(e){e.stopPropagation(),n.animating?e.preventDefault():(n.pause(),t._gesture.addPointer(e.pointerId),T=0,c=d?n.h:n.w,f=Number(new Date),l=v&&u&&n.animatingTo===n.last?0:v&&u?n.limit-(n.itemW+n.vars.itemMargin)*n.move*n.animatingTo:v&&n.currentSlide===n.last?n.limit:v?(n.itemW+n.vars.itemMargin)*n.move*n.currentSlide:u?(n.last-n.currentSlide+n.cloneOffset)*c:(n.currentSlide+n.cloneOffset)*c)}function a(e){e.stopPropagation();var a=e.target._slider;if(a){var n=-e.translationX,i=-e.translationY;return T+=d?i:n,m=T,y=d?Math.abs(T)<Math.abs(-n):Math.abs(T)<Math.abs(-i),e.detail===e.MSGESTURE_FLAG_INERTIA?void setImmediate(function(){t._gesture.stop()}):void((!y||Number(new Date)-f>500)&&(e.preventDefault(),!p&&a.transitions&&(a.vars.animationLoop||(m=T/(0===a.currentSlide&&0>T||a.currentSlide===a.last&&T>0?Math.abs(T)/c+2:1)),a.setProps(l+m,"setTouch"))))}}function i(e){e.stopPropagation();var t=e.target._slider;if(t){if(t.animatingTo===t.currentSlide&&!y&&null!==m){var a=u?-m:m,n=a>0?t.getTarget("next"):t.getTarget("prev");t.canAdvance(n)&&(Number(new Date)-f<550&&Math.abs(a)>50||Math.abs(a)>c/2)?t.flexAnimate(n,t.vars.pauseOnAction):p||t.flexAnimate(t.currentSlide,t.vars.pauseOnAction,!0)}r=null,o=null,m=null,l=null,T=0}}var r,o,l,c,m,f,g,h,S,y=!1,x=0,b=0,T=0;s?(t.style.msTouchAction="none",t._gesture=new MSGesture,t._gesture.target=t,t.addEventListener("MSPointerDown",e,!1),t._slider=n,t.addEventListener("MSGestureChange",a,!1),t.addEventListener("MSGestureEnd",i,!1)):(g=function(e){n.animating?e.preventDefault():(window.navigator.msPointerEnabled||1===e.touches.length)&&(n.pause(),c=d?n.h:n.w,f=Number(new Date),x=e.touches[0].pageX,b=e.touches[0].pageY,l=v&&u&&n.animatingTo===n.last?0:v&&u?n.limit-(n.itemW+n.vars.itemMargin)*n.move*n.animatingTo:v&&n.currentSlide===n.last?n.limit:v?(n.itemW+n.vars.itemMargin)*n.move*n.currentSlide:u?(n.last-n.currentSlide+n.cloneOffset)*c:(n.currentSlide+n.cloneOffset)*c,r=d?b:x,o=d?x:b,t.addEventListener("touchmove",h,!1),t.addEventListener("touchend",S,!1))},h=function(e){x=e.touches[0].pageX,b=e.touches[0].pageY,m=d?r-b:r-x,y=d?Math.abs(m)<Math.abs(x-o):Math.abs(m)<Math.abs(b-o);var t=500;(!y||Number(new Date)-f>t)&&(e.preventDefault(),!p&&n.transitions&&(n.vars.animationLoop||(m/=0===n.currentSlide&&0>m||n.currentSlide===n.last&&m>0?Math.abs(m)/c+2:1),n.setProps(l+m,"setTouch")))},S=function(e){if(t.removeEventListener("touchmove",h,!1),n.animatingTo===n.currentSlide&&!y&&null!==m){var a=u?-m:m,i=a>0?n.getTarget("next"):n.getTarget("prev");n.canAdvance(i)&&(Number(new Date)-f<550&&Math.abs(a)>50||Math.abs(a)>c/2)?n.flexAnimate(i,n.vars.pauseOnAction):p||n.flexAnimate(n.currentSlide,n.vars.pauseOnAction,!0)}t.removeEventListener("touchend",S,!1),r=null,o=null,m=null,l=null},t.addEventListener("touchstart",g,!1))},resize:function(){!n.animating&&n.is(":visible")&&(v||n.doMath(),p?f.smoothHeight():v?(n.slides.width(n.computedW),n.update(n.pagingCount),n.setProps()):d?(n.viewport.height(n.h),n.setProps(n.h,"setTotal")):(n.vars.smoothHeight&&f.smoothHeight(),n.newSlides.width(n.computedW),n.setProps(n.computedW,"setTotal")))},smoothHeight:function(e){if(!d||p){var t=p?n:n.viewport;e?t.animate({height:n.slides.eq(n.animatingTo).innerHeight()},e):t.innerHeight(n.slides.eq(n.animatingTo).innerHeight())}},sync:function(e){var t=$(n.vars.sync).data("flexslider"),a=n.animatingTo;switch(e){case"animate":t.flexAnimate(a,n.vars.pauseOnAction,!1,!0);break;case"play":t.playing||t.asNav||t.play();break;case"pause":t.pause()}},uniqueID:function(e){return e.filter("[id]").add(e.find("[id]")).each(function(){var e=$(this);e.attr("id",e.attr("id")+"_clone")}),e},pauseInvisible:{visProp:null,init:function(){var e=f.pauseInvisible.getHiddenProp();if(e){var t=e.replace(/[H|h]idden/,"")+"visibilitychange";document.addEventListener(t,function(){f.pauseInvisible.isHidden()?n.startTimeout?clearTimeout(n.startTimeout):n.pause():n.started?n.play():n.vars.initDelay>0?setTimeout(n.play,n.vars.initDelay):n.play()})}},isHidden:function(){var e=f.pauseInvisible.getHiddenProp();return e?document[e]:!1},getHiddenProp:function(){var e=["webkit","moz","ms","o"];if("hidden"in document)return"hidden";for(var t=0;t<e.length;t++)if(e[t]+"Hidden"in document)return e[t]+"Hidden";return null}},setToClearWatchedEvent:function(){clearTimeout(c),c=setTimeout(function(){l=""},3e3)}},n.flexAnimate=function(e,t,a,s,o){if(n.vars.animationLoop||e===n.currentSlide||(n.direction=e>n.currentSlide?"next":"prev"),m&&1===n.pagingCount&&(n.direction=n.currentItem<e?"next":"prev"),!n.animating&&(n.canAdvance(e,o)||a)&&n.is(":visible")){if(m&&s){var l=$(n.vars.asNavFor).data("flexslider");if(n.atEnd=0===e||e===n.count-1,l.flexAnimate(e,!0,!1,!0,o),n.direction=n.currentItem<e?"next":"prev",l.direction=n.direction,Math.ceil((e+1)/n.visible)-1===n.currentSlide||0===e)return n.currentItem=e,n.slides.removeClass(i+"active-slide").eq(e).addClass(i+"active-slide"),!1;n.currentItem=e,n.slides.removeClass(i+"active-slide").eq(e).addClass(i+"active-slide"),e=Math.floor(e/n.visible)}if(n.animating=!0,n.animatingTo=e,t&&n.pause(),n.vars.before(n),n.syncExists&&!o&&f.sync("animate"),n.vars.controlNav&&f.controlNav.active(),v||n.slides.removeClass(i+"active-slide").eq(e).addClass(i+"active-slide"),n.atEnd=0===e||e===n.last,n.vars.directionNav&&f.directionNav.update(),e===n.last&&(n.vars.end(n),n.vars.animationLoop||n.pause()),p)r?(n.slides.eq(n.currentSlide).css({opacity:0,zIndex:1}),n.slides.eq(e).css({opacity:1,zIndex:2}),n.wrapup(c)):(n.slides.eq(n.currentSlide).css({zIndex:1}).animate({opacity:0},n.vars.animationSpeed,n.vars.easing),n.slides.eq(e).css({zIndex:2}).animate({opacity:1},n.vars.animationSpeed,n.vars.easing,n.wrapup));else{var c=d?n.slides.filter(":first").height():n.computedW,g,h,S;v?(g=n.vars.itemMargin,S=(n.itemW+g)*n.move*n.animatingTo,h=S>n.limit&&1!==n.visible?n.limit:S):h=0===n.currentSlide&&e===n.count-1&&n.vars.animationLoop&&"next"!==n.direction?u?(n.count+n.cloneOffset)*c:0:n.currentSlide===n.last&&0===e&&n.vars.animationLoop&&"prev"!==n.direction?u?0:(n.count+1)*c:u?(n.count-1-e+n.cloneOffset)*c:(e+n.cloneOffset)*c,n.setProps(h,"",n.vars.animationSpeed),n.transitions?(n.vars.animationLoop&&n.atEnd||(n.animating=!1,n.currentSlide=n.animatingTo),n.container.unbind("webkitTransitionEnd transitionend"),n.container.bind("webkitTransitionEnd transitionend",function(){clearTimeout(n.ensureAnimationEnd),n.wrapup(c)}),clearTimeout(n.ensureAnimationEnd),n.ensureAnimationEnd=setTimeout(function(){n.wrapup(c)},n.vars.animationSpeed+100)):n.container.animate(n.args,n.vars.animationSpeed,n.vars.easing,function(){n.wrapup(c)})}n.vars.smoothHeight&&f.smoothHeight(n.vars.animationSpeed)}},n.wrapup=function(e){p||v||(0===n.currentSlide&&n.animatingTo===n.last&&n.vars.animationLoop?n.setProps(e,"jumpEnd"):n.currentSlide===n.last&&0===n.animatingTo&&n.vars.animationLoop&&n.setProps(e,"jumpStart")),n.animating=!1,n.currentSlide=n.animatingTo,n.vars.after(n)},n.animateSlides=function(){!n.animating&&e&&n.flexAnimate(n.getTarget("next"))},n.pause=function(){clearInterval(n.animatedSlides),n.animatedSlides=null,n.playing=!1,n.vars.pausePlay&&f.pausePlay.update("play"),n.syncExists&&f.sync("pause")},n.play=function(){n.playing&&clearInterval(n.animatedSlides),n.animatedSlides=n.animatedSlides||setInterval(n.animateSlides,n.vars.slideshowSpeed),n.started=n.playing=!0,n.vars.pausePlay&&f.pausePlay.update("pause"),n.syncExists&&f.sync("play")},n.stop=function(){n.pause(),n.stopped=!0},n.canAdvance=function(e,t){var a=m?n.pagingCount-1:n.last;return t?!0:m&&n.currentItem===n.count-1&&0===e&&"prev"===n.direction?!0:m&&0===n.currentItem&&e===n.pagingCount-1&&"next"!==n.direction?!1:e!==n.currentSlide||m?n.vars.animationLoop?!0:n.atEnd&&0===n.currentSlide&&e===a&&"next"!==n.direction?!1:!n.atEnd||n.currentSlide!==a||0!==e||"next"!==n.direction:!1},n.getTarget=function(e){return n.direction=e,"next"===e?n.currentSlide===n.last?0:n.currentSlide+1:0===n.currentSlide?n.last:n.currentSlide-1},n.setProps=function(e,t,a){var i=function(){var a=e?e:(n.itemW+n.vars.itemMargin)*n.move*n.animatingTo,i=function(){if(v)return"setTouch"===t?e:u&&n.animatingTo===n.last?0:u?n.limit-(n.itemW+n.vars.itemMargin)*n.move*n.animatingTo:n.animatingTo===n.last?n.limit:a;switch(t){case"setTotal":return u?(n.count-1-n.currentSlide+n.cloneOffset)*e:(n.currentSlide+n.cloneOffset)*e;case"setTouch":return u?e:e;case"jumpEnd":return u?e:n.count*e;case"jumpStart":return u?n.count*e:e;default:return e}}();return-1*i+"px"}();n.transitions&&(i=d?"translate3d(0,"+i+",0)":"translate3d("+i+",0,0)",a=void 0!==a?a/1e3+"s":"0s",n.container.css("-"+n.pfx+"-transition-duration",a),n.container.css("transition-duration",a)),n.args[n.prop]=i,(n.transitions||void 0===a)&&n.container.css(n.args),n.container.css("transform",i)},n.setup=function(e){if(p)n.slides.css({width:"100%","float":"left",marginRight:"-100%",position:"relative"}),"init"===e&&(r?n.slides.css({opacity:0,display:"block",webkitTransition:"opacity "+n.vars.animationSpeed/1e3+"s ease",zIndex:1}).eq(n.currentSlide).css({opacity:1,zIndex:2}):0==n.vars.fadeFirstSlide?n.slides.css({opacity:0,display:"block",zIndex:1}).eq(n.currentSlide).css({zIndex:2}).css({opacity:1}):n.slides.css({opacity:0,display:"block",zIndex:1}).eq(n.currentSlide).css({zIndex:2}).animate({opacity:1},n.vars.animationSpeed,n.vars.easing)),n.vars.smoothHeight&&f.smoothHeight();else{var t,a;"init"===e&&(n.viewport=$('<div class="'+i+'viewport"></div>').css({overflow:"hidden",position:"relative"}).appendTo(n).append(n.container),n.cloneCount=0,n.cloneOffset=0,u&&(a=$.makeArray(n.slides).reverse(),n.slides=$(a),n.container.empty().append(n.slides))),n.vars.animationLoop&&!v&&(n.cloneCount=2,n.cloneOffset=1,"init"!==e&&n.container.find(".clone").remove(),n.container.append(f.uniqueID(n.slides.first().clone().addClass("clone")).attr("aria-hidden","true")).prepend(f.uniqueID(n.slides.last().clone().addClass("clone")).attr("aria-hidden","true"))),n.newSlides=$(n.vars.selector,n),t=u?n.count-1-n.currentSlide+n.cloneOffset:n.currentSlide+n.cloneOffset,d&&!v?(n.container.height(200*(n.count+n.cloneCount)+"%").css("position","absolute").width("100%"),setTimeout(function(){n.newSlides.css({display:"block"}),n.doMath(),n.viewport.height(n.h),n.setProps(t*n.h,"init")},"init"===e?100:0)):(n.container.width(200*(n.count+n.cloneCount)+"%"),n.setProps(t*n.computedW,"init"),setTimeout(function(){n.doMath(),n.newSlides.css({width:n.computedW,marginRight:n.computedM,"float":"left",display:"block"}),n.vars.smoothHeight&&f.smoothHeight()},"init"===e?100:0))}v||n.slides.removeClass(i+"active-slide").eq(n.currentSlide).addClass(i+"active-slide"),n.vars.init(n)},n.doMath=function(){var e=n.slides.first(),t=n.vars.itemMargin,a=n.vars.minItems,i=n.vars.maxItems;n.w=void 0===n.viewport?n.width():n.viewport.width(),n.h=e.height(),n.boxPadding=e.outerWidth()-e.width(),v?(n.itemT=n.vars.itemWidth+t,n.itemM=t,n.minW=a?a*n.itemT:n.w,n.maxW=i?i*n.itemT-t:n.w,n.itemW=n.minW>n.w?(n.w-t*(a-1))/a:n.maxW<n.w?(n.w-t*(i-1))/i:n.vars.itemWidth>n.w?n.w:n.vars.itemWidth,n.visible=Math.floor(n.w/n.itemW),n.move=n.vars.move>0&&n.vars.move<n.visible?n.vars.move:n.visible,n.pagingCount=Math.ceil((n.count-n.visible)/n.move+1),n.last=n.pagingCount-1,n.limit=1===n.pagingCount?0:n.vars.itemWidth>n.w?n.itemW*(n.count-1)+t*(n.count-1):(n.itemW+t)*n.count-n.w-t):(n.itemW=n.w,n.itemM=t,n.pagingCount=n.count,n.last=n.count-1),n.computedW=n.itemW-n.boxPadding,n.computedM=n.itemM},n.update=function(e,t){n.doMath(),v||(e<n.currentSlide?n.currentSlide+=1:e<=n.currentSlide&&0!==e&&(n.currentSlide-=1),n.animatingTo=n.currentSlide),n.vars.controlNav&&!n.manualControls&&("add"===t&&!v||n.pagingCount>n.controlNav.length?f.controlNav.update("add"):("remove"===t&&!v||n.pagingCount<n.controlNav.length)&&(v&&n.currentSlide>n.last&&(n.currentSlide-=1,n.animatingTo-=1),f.controlNav.update("remove",n.last))),n.vars.directionNav&&f.directionNav.update()},n.addSlide=function(e,t){var a=$(e);n.count+=1,n.last=n.count-1,d&&u?void 0!==t?n.slides.eq(n.count-t).after(a):n.container.prepend(a):void 0!==t?n.slides.eq(t).before(a):n.container.append(a),n.update(t,"add"),n.slides=$(n.vars.selector+":not(.clone)",n),n.setup(),n.vars.added(n)},n.removeSlide=function(e){var t=isNaN(e)?n.slides.index($(e)):e;n.count-=1,n.last=n.count-1,isNaN(e)?$(e,n.slides).remove():d&&u?n.slides.eq(n.last).remove():n.slides.eq(e).remove(),n.doMath(),n.update(t,"remove"),n.slides=$(n.vars.selector+":not(.clone)",n),n.setup(),n.vars.removed(n)},f.init()},$(window).blur(function(t){e=!1}).focus(function(t){e=!0}),$.flexslider.defaults={namespace:"flex-",selector:".slides > li",animation:"fade",easing:"swing",direction:"horizontal",reverse:!1,animationLoop:!0,smoothHeight:!1,startAt:0,slideshow:!0,slideshowSpeed:7e3,animationSpeed:600,initDelay:0,randomize:!1,fadeFirstSlide:!0,thumbCaptions:!1,pauseOnAction:!0,pauseOnHover:!1,pauseInvisible:!0,useCSS:!0,touch:!0,video:!1,controlNav:!0,directionNav:!0,prevText:"Previous",nextText:"Next",keyboard:!0,multipleKeyboard:!1,mousewheel:!1,pausePlay:!1,pauseText:"Pause",playText:"Play",controlsContainer:"",manualControls:"",customDirectionNav:"",sync:"",asNavFor:"",itemWidth:0,itemMargin:0,minItems:1,maxItems:0,move:0,allowOneSlide:!0,start:function(){},before:function(){},after:function(){},end:function(){},added:function(){},removed:function(){},init:function(){}},$.fn.flexslider=function(e){if(void 0===e&&(e={}),"object"==typeof e)return this.each(function(){var t=$(this),a=e.selector?e.selector:".slides > li",n=t.find(a);1===n.length&&e.allowOneSlide===!1||0===n.length?(n.fadeIn(400),e.start&&e.start(t)):void 0===t.data("flexslider")&&new $.flexslider(this,e)});var t=$(this).data("flexslider");switch(e){case"play":t.play();break;case"pause":t.pause();break;case"stop":t.stop();break;case"next":t.flexAnimate(t.getTarget("next"),!0);break;case"prev":case"previous":t.flexAnimate(t.getTarget("prev"),!0);break;default:"number"==typeof e&&t.flexAnimate(e,!0)}}}(jQuery);
 
/**
 * Minified by jsDelivr using Terser v3.14.1.
 * Original file: /npm/jquery-scrollify@1.0.20/jquery.scrollify.js
 * 
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
!function(e,t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],function(o){return t(o,e,e.document)}):"object"==typeof module&&module.exports?module.exports=t(require("jquery"),e,e.document):t(jQuery,e,e.document)}("undefined"!=typeof window?window:this,function(e,t,o,n){"use strict";var r,s,i,a,c,l,u=[],h=[],f=[],d=[],p=0,m=0,g=1,v=!1,y=e(t),w=y.scrollTop(),S=!1,E=!1,H=!1,b=!1,M=[],x=(new Date).getTime(),T=!0,D=!1,I=0,L="onwheel"in o?"wheel":o.onmousewheel!==n?"mousewheel":"DOMMouseScroll",N={section:".section",sectionName:"section-name",interstitialSection:"",easing:"easeOutExpo",scrollSpeed:1100,offset:0,scrollbars:!0,target:"html,body",standardScrollElements:!1,setHeights:!0,overflowScroll:!0,updateHash:!0,touchScroll:!0,before:function(){},after:function(){},afterResize:function(){},afterRender:function(){}};function k(){return y.height()+N.offset}function O(o,n,r,s){if(m===o&&(r=!1),!0===b)return!0;if(h[o]){if(S=!1,!0===T&&(T=!1,N.afterRender()),r&&"function"==typeof N.before&&!1===N.before(o,f))return!0;if(g=1,I=o?u[o]:0,!1===T&&m>o&&!1===s&&d[o]&&(i=k(),g=parseInt(f[o].outerHeight()/i),I=parseInt(u[o])+(f[o].outerHeight()-i)),N.updateHash&&N.sectionName&&(!0!==T||0!==o))if(history.pushState)try{history.replaceState(null,null,h[o])}catch(e){t.console&&console.warn("Scrollify warning: Page must be hosted to manipulate the hash value.")}else t.location.hash=h[o];if(m=o,n)e(N.target).stop().scrollTop(I),r&&N.after(o,f);else{if(E=!0,e().velocity?e(N.target).stop().velocity("scroll",{duration:N.scrollSpeed,easing:N.easing,offset:I,mobileHA:!1}):e(N.target).stop().animate({scrollTop:I},N.scrollSpeed,N.easing),t.location.hash.length&&N.sectionName&&t.console)try{e(t.location.hash).length&&console.warn("Scrollify warning: ID matches hash value - this will cause the page to anchor.")}catch(e){}e(N.target).promise().done(function(){E=!1,T=!1,r&&N.after(o,f)})}}}function z(e){function t(t){for(var o=0,n=e.slice(Math.max(e.length-t,1)),r=0;r<n.length;r++)o+=n[r];return Math.ceil(o/t)}return t(10)>=t(70)}var R=function(n){function m(t){e().velocity?e(N.target).stop().velocity("scroll",{duration:N.scrollSpeed,easing:N.easing,offset:t,mobileHA:!1}):e(N.target).stop().animate({scrollTop:t},N.scrollSpeed,N.easing)}function T(t){t&&(w=y.scrollTop());var o=N.section;d=[],N.interstitialSection.length&&(o+=","+N.interstitialSection),!1===N.scrollbars&&(N.overflowScroll=!1),i=k(),e(o).each(function(t){var o=e(this);N.setHeights?o.is(N.interstitialSection)?d[t]=!1:o.css("height","auto").outerHeight()<i||"hidden"===o.css("overflow")?(o.css({height:i}),d[t]=!1):(o.css({height:o.outerHeight()}),N.overflowScroll?d[t]=!0:d[t]=!1):o.outerHeight()<i||!1===N.overflowScroll?d[t]=!1:d[t]=!0}),t&&y.scrollTop(w)}function I(o,n){var r=N.section;N.interstitialSection.length&&(r+=","+N.interstitialSection),u=[],h=[],f=[],e(r).each(function(o){var n=e(this);u[o]=o>0?parseInt(n.offset().top)+N.offset:parseInt(n.offset().top),N.sectionName&&n.data(N.sectionName)?h[o]="#"+n.data(N.sectionName).toString().replace(/ /g,"-"):!1===n.is(N.interstitialSection)?h[o]="#"+(o+1):(h[o]="#",o===e(r).length-1&&o>1&&(u[o]=u[o-1]+(parseInt(e(e(r)[o-1]).outerHeight())-parseInt(e(t).height()))+parseInt(n.outerHeight()))),f[o]=n;try{e(h[o]).length&&t.console&&console.warn("Scrollify warning: Section names can't match IDs - this will cause the browser to anchor.")}catch(e){}t.location.hash===h[o]&&(p=o,v=!0)}),!0===o&&O(p,!1,!1,!1)}function R(){return!d[p]||!((w=y.scrollTop())>parseInt(u[p]))}function j(){return!d[p]||(w=y.scrollTop(),i=k(),!(w<parseInt(u[p])+(f[p].outerHeight()-i)-28))}D=!0,e.easing.easeOutExpo=function(e,t,o,n,r){return t==r?o+n:n*(1-Math.pow(2,-10*t/r))+o},a={handleMousedown:function(){if(!0===b)return!0;S=!1,H=!1},handleMouseup:function(){if(!0===b)return!0;S=!0,H&&a.calculateNearest(!1,!0)},handleScroll:function(){if(!0===b)return!0;r&&clearTimeout(r),r=setTimeout(function(){if(H=!0,!1===S)return!1;S=!1,a.calculateNearest(!1,!0)},200)},calculateNearest:function(e,t){w=y.scrollTop();for(var o,n=1,r=u.length,s=0,i=Math.abs(u[0]-w);n<r;n++)(o=Math.abs(u[n]-w))<i&&(i=o,s=n);(j()&&s>p||R())&&(p=s,O(s,e,t,!1))},wheelHandler:function(o){if(!0===b)return!0;if(N.standardScrollElements&&(e(o.target).is(N.standardScrollElements)||e(o.target).closest(N.standardScrollElements).length))return!0;d[p]||o.preventDefault();var n,r=(new Date).getTime();n=(o=o||t.event).originalEvent?o.originalEvent.wheelDelta||-o.originalEvent.deltaY||-o.originalEvent.detail:o.wheelDelta||-o.deltaY||-o.detail;var s=Math.max(-1,Math.min(1,n));if(M.length>149&&M.shift(),M.push(Math.abs(n)),r-x>200&&(M=[]),x=r,E)return!1;if(s<0){if(p<u.length-1&&j()){if(!z(M))return!1;o.preventDefault(),E=!0,O(++p,!1,!0,!1)}}else if(s>0&&p>0&&R()){if(!z(M))return!1;o.preventDefault(),E=!0,O(--p,!1,!0,!1)}},keyHandler:function(t){return!0===b||!1===o.activeElement.readOnly||(!(!N.standardScrollElements||!e(t.target).is(N.standardScrollElements)&&!e(t.target).closest(N.standardScrollElements).length)||!0!==E&&void(38==t.keyCode||33==t.keyCode?p>0&&R()&&(t.preventDefault(),O(--p,!1,!0,!1)):40!=t.keyCode&&34!=t.keyCode||p<u.length-1&&j()&&(t.preventDefault(),O(++p,!1,!0,!1))))},init:function(){N.scrollbars?(y.on("mousedown",a.handleMousedown),y.on("mouseup",a.handleMouseup),y.on("scroll",a.handleScroll)):e("body").css({overflow:"hidden"}),t.addEventListener(L,a.wheelHandler,{passive:!1}),y.on("keydown",a.keyHandler)}},c={touches:{touchstart:{y:-1,x:-1},touchmove:{y:-1,x:-1},touchend:!1,direction:"undetermined"},options:{distance:30,timeGap:800,timeStamp:(new Date).getTime()},touchHandler:function(t){if(!0===b)return!0;if(N.standardScrollElements&&(e(t.target).is(N.standardScrollElements)||e(t.target).closest(N.standardScrollElements).length))return!0;var o;if(void 0!==t&&void 0!==t.touches)switch(o=t.touches[0],t.type){case"touchstart":c.touches.touchstart.y=o.pageY,c.touches.touchmove.y=-1,c.touches.touchstart.x=o.pageX,c.touches.touchmove.x=-1,c.options.timeStamp=(new Date).getTime(),c.touches.touchend=!1;case"touchmove":c.touches.touchmove.y=o.pageY,c.touches.touchmove.x=o.pageX,c.touches.touchstart.y!==c.touches.touchmove.y&&Math.abs(c.touches.touchstart.y-c.touches.touchmove.y)>Math.abs(c.touches.touchstart.x-c.touches.touchmove.x)&&(t.preventDefault(),c.touches.direction="y",c.options.timeStamp+c.options.timeGap<(new Date).getTime()&&0==c.touches.touchend&&(c.touches.touchend=!0,c.touches.touchstart.y>-1&&Math.abs(c.touches.touchmove.y-c.touches.touchstart.y)>c.options.distance&&(c.touches.touchstart.y<c.touches.touchmove.y?c.up():c.down())));break;case"touchend":!1===c.touches[t.type]&&(c.touches[t.type]=!0,c.touches.touchstart.y>-1&&c.touches.touchmove.y>-1&&"y"===c.touches.direction&&(Math.abs(c.touches.touchmove.y-c.touches.touchstart.y)>c.options.distance&&(c.touches.touchstart.y<c.touches.touchmove.y?c.up():c.down()),c.touches.touchstart.y=-1,c.touches.touchstart.x=-1,c.touches.direction="undetermined"))}},down:function(){p<u.length&&(j()&&p<u.length-1?O(++p,!1,!0,!1):(i=k(),Math.floor(f[p].height()/i)>g?(m(parseInt(u[p])+i*g),g+=1):m(parseInt(u[p])+(f[p].outerHeight()-i))))},up:function(){p>=0&&(R()&&p>0?O(--p,!1,!0,!1):g>2?(i=k(),g-=1,m(parseInt(u[p])+i*g)):(g=1,m(parseInt(u[p]))))},init:function(){if(o.addEventListener&&N.touchScroll){var e={passive:!1};o.addEventListener("touchstart",c.touchHandler,e),o.addEventListener("touchmove",c.touchHandler,e),o.addEventListener("touchend",c.touchHandler,e)}}},l={refresh:function(e,t){clearTimeout(s),s=setTimeout(function(){T(!0),I(t,!1),e&&N.afterResize()},400)},handleUpdate:function(){l.refresh(!1,!1)},handleResize:function(){l.refresh(!0,!1)},handleOrientation:function(){l.refresh(!0,!0)}},N=e.extend(N,n),T(!1),I(!1,!0),!0===v?O(p,!1,!0,!0):setTimeout(function(){a.calculateNearest(!0,!1)},200),u.length&&(a.init(),c.init(),y.on("resize",l.handleResize),o.addEventListener&&t.addEventListener("orientationchange",l.handleOrientation,!1))};function j(e,t){for(var o=h.length;o>=0;o--)"string"==typeof e?h[o]===e&&(p=o,O(o,t,!0,!0)):o===e&&(p=o,O(o,t,!0,!0))}return R.move=function(t){if(t===n)return!1;t.originalEvent&&(t=e(this).attr("href")),j(t,!1)},R.instantMove=function(e){if(e===n)return!1;j(e,!0)},R.next=function(){p<h.length&&O(p+=1,!1,!0,!0)},R.previous=function(){p>0&&O(p-=1,!1,!0,!0)},R.instantNext=function(){p<h.length&&O(p+=1,!0,!0,!0)},R.instantPrevious=function(){p>0&&O(p-=1,!0,!0,!0)},R.destroy=function(){if(!D)return!1;N.setHeights&&e(N.section).each(function(){e(this).css("height","auto")}),y.off("resize",l.handleResize),N.scrollbars&&(y.off("mousedown",a.handleMousedown),y.off("mouseup",a.handleMouseup),y.off("scroll",a.handleScroll)),t.removeEventListener(L,a.wheelHandler),y.off("keydown",a.keyHandler),o.addEventListener&&N.touchScroll&&(o.removeEventListener("touchstart",c.touchHandler,!1),o.removeEventListener("touchmove",c.touchHandler,!1),o.removeEventListener("touchend",c.touchHandler,!1)),u=[],h=[],f=[],d=[]},R.update=function(){if(!D)return!1;l.handleUpdate()},R.current=function(){return f[p]},R.currentIndex=function(){return p},R.disable=function(){b=!0},R.enable=function(){b=!1,D&&a.calculateNearest(!1,!1)},R.isDisabled=function(){return b},R.setOptions=function(o){if(!D)return!1;"object"==typeof o?(N=e.extend(N,o),l.handleUpdate()):t.console&&console.warn("Scrollify warning: setOptions expects an object.")},e.scrollify=R,R});
//# sourceMappingURL=/sm/991b3317884d99d934c4e5067ad9f7358456f4563d55a156ba9a4e7c3f9184d0.map

/* jshint ignore:end */